import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export type SnackbarStatus = 'success' | 'warning' | 'error' | 'info';

export interface ISnackbarData {
    message: string;
    status: SnackbarStatus;
    /** Values for the message's translation placeholders. */
    params?: Record<string, unknown>;
    /** Translation key of an action button, e.g. "Undo". */
    action?: string;
}

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrl: './snackbar.component.scss',
    standalone: false,
})
export class SnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: ISnackbarData,
        private snackBarRef: MatSnackBarRef<SnackbarComponent>
    ) {}

    getIcon(status: SnackbarStatus): string {
        switch (status) {
            case 'success':
                return 'check_circle';
            case 'warning':
                return 'warning';
            case 'error':
                return 'error';
            default:
                return 'info';
        }
    }

    close(): void {
        this.snackBarRef.dismiss();
    }

    act(): void {
        this.snackBarRef.dismissWithAction();
    }
}
